export function transformToParams (object) {
  let params = ''
  Object.entries(object).forEach(([key, value]) => {
    params += '&' + key + '=' + encodeURIComponent(value)
  })

  return params
}
